<template>
<!-- 企业培训 -->
  <div class="training">
    <div class="item banner" >
      <img class="item-img"  src="https://qiniu.swarma.org/business/jpg/training/banner.png" alt="集智学园">
    </div>
    <!-- 介绍 -->
    <div class="item" v-for="(item,i) in bannerList"  :key="i">
      <img class="item-img"  :src="item.src" alt="集智学园">
      <div class="item-text" >
        <h1 class="item-title" :style="{color:item.titleColor}">{{item.title}}</h1>
        <div class="item-content" :style="{color:item.contentColor}">{{item.content}}</div>
      </div>
    </div>
    <!-- 课程特色 -->
    <section class="section-item spectial-list">
      <h1 class="title">课程特色</h1>
      <div class="special-item" v-for="(item, i) in spacialList" :key="i">
        <img :src="item.pic" alt="集智学园">
        <h3>{{item.title}}</h3>
        <p>{{item.content}}</p>
      </div>
    </section>
    <!-- 课程类型 -->
    <section class="section-item course-type">
      <h1 class="title">课程类型</h1>
      <div class="type-item">
        <h3>技术培训</h3>
        <p>《python数据科学与机器学习》</p>
        <p>《如何打造你自己的聊天机器人》</p>
        <p>《中文自然语言理解在中文中的应用》</p>
        <p>《自然语言处理与深度学习》</p>
        <p>《计算机视觉与深度学习》</p>
        <p>《火炬上的深度学习》</p>
      </div>
      <div class="type-item">
        <h3>思维升级</h3>
        <p>《复杂性科学》</p>
        <p>《迎接AI时代》</p>
        <p>《走近2050—人工智能、注意力与互联网》</p>
        <p>《机器学习思维》</p>
        <p>《企业生长的规模法则》</p>
      </div>
    </section>
    <div class="item">
        <img class="item-img"  src="https://qiniu.swarma.org/business/jpg/training/bg_qiye5.png" alt="集智学园">
        <div class="footer-item-text item-text">
          <h1 class="title">课程流程</h1>
          <span class="text">1.课前需求沟通</span>
          <span class="text">2.学员基础调研</span>
          <span class="text">3.课程定制设计</span>
          <span class="text">4.培训课程实施</span>
          <span class="text">5.课后效果评估</span>
          <span class="text">6.培训效果跟踪</span>
        </div>
   </div>
  </div>
</template>

<script>
export default {
  name: 'case',
  data () {
    return {
      bannerList: [{
        title: '面向企业管理层/技术人员',
        titleColor: '#0036D1 ',
        content: '集智学园企业培训主要面向企业管理者、中高级技术人员、工程师，针对不同行业及企业的需求提供人工智能、机器学习、大数据、复杂系统等领域的系列讲解课程和定制化的企业咨询服务。',
        contentColor: '#333',
        src: 'https://qiniu.swarma.org/business/jpg/training/bg_qiye1.png'
      }],
      // 课程特色
      spacialList: [{
        pic: 'https://qiniu.swarma.org/business/jpg/training/bg_qiye2.png',
        title: '独家设计 量身定做',
        content: '针对不同企业，不同的行业背景和学员背景，集智学园提前进行企业调研，一对一设计课程，保证提供的课程能更贴合受众认知水平。'
      }, {
        pic: 'https://qiniu.swarma.org/business/jpg/training/bg_qiye3.png',
        title: '行业前沿 经验丰富',
        content: '集智学园企业课程依托集智俱乐部在复杂系统和人工智能领域多年的探索，已经形成了一套完善的课程流程，服务了很多大的科技公司和企业。'
      }, {
        pic: 'https://qiniu.swarma.org/business/jpg/training/bg_qiye4.png',
        title: '线上线下相结合',
        content: '购买集智学园企业服务即赠送线上课！学员课前通过集智学园官网提供的视频预习；到企业做线下的内训；课后学员可通过线上课程巩固和拓展；'
      }]
    }
  }
}
</script>
<style lang="less" scoped>
.item {
  position: relative;
  .item-img {
    height: 100%;
    margin: 0;
    display: inherit;
  }
  .item-text {
    position: absolute;
    left: 20%;
    color: #fff;
    top: 50%;
    font-size: 16px;
    transform: translateY(-50%);
    line-height: 28px;
    .item-title {
      font-weight: normal;
      font-size: 42px;
      height: 80px;
      line-height: 80px;
      margin: 10px 0;
    }
    .item-content {
      width:35%;
    }
  }
  .footer-item-text {
    left: 0;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    text-align: center;
    color: #666;
    padding: 5% 20%;
    box-sizing: border-box;
    width: 100%;
    h1.title {
      color: #333;
      margin-bottom: 20px;
      font-weight: normal;
      width: 100%;
    }
    .text {
      line-height: 35px;
      width: 33%;
    }
  }
}
.section-item {
  padding: 100px 10%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  color: #333;
  font-size: 14px;
  p {
    color: #8A8A8A;
  }
  &.spectial-list .special-item {
    width: 28%;
    h3 {
      font-weight: normal;
      margin: 15px 0;
    }
    img {
      width: 100%;
    }

  }
  &.course-type {
    background: #F4F5F6;
    .type-item {
      width: 47%;
      text-align: right;
      &:last-child {
        text-align: left;
      }
      h3 {
        font-weight: normal;
        margin: 15px 0;
        display: inline-block;
        background: #F5A623;
        color: #fff;
        padding: 5px 8px;
      }
    }
  }
}
// ipad
@media screen and(max-width: 769px) {
  .section-item {
    padding: 70px 5%;
  }
  .item {
    &.banner {
      .item-img {
        height: inherit;
        width: 100%;
      }
    }
    .item-img {
      height: 80%;
      margin: 0;
      display: inherit;
      width: 226%;
    }
    .item-text {
      position: absolute;
      padding: 0 10%;
      left: 0;
      color: #fff;
      font-size: 12px;
      line-height: 20px;
      .item-title {
        font-weight: normal;
        font-size: 18px;
        height: 47px;
        line-height: 63px;
        margin: 10px 0;
      }
      .item-content {
        width: inherit;
        min-width: inherit;
      }
    }
  }
}
// 移动
@media screen and(max-width: 414px) {
  .section-item {
    padding: 30px 5%;
    &.spectial-list .special-item {
      width: 100%;
      margin: 20px 0;
    }
    &.course-type {
      .type-item {
        width: 100%;
        text-align: center;
        &:last-child {
          text-align: center;
        }
      }
    }
  }
  .item {
    .footer-item-text {
      padding: 5% 10%;
      .text {
        width: 50%;
      }
    }
  }
}
</style>
